<div class="container-fluid wrapper-page">
  <div align="center">
    <h4 class="mt-2 mb-2">EDIT PROFILE - PATIENT</h4>
  </div>
  <div class="page-head">
    <h5><a href="javascript:void(0)"><i class="fa fa-arrow-circle-left" (click)="getback()"> BACK
        </i></a>
    </h5>
  </div>
  <div class="row">
    <div class="col-lg-12 col-12 col-sm-12 col-md-12">
      <div class="card m-b-30">
        <div class="card-body">
          <!----========   EDIT PATIENT PROFILE INFORMATION =========================  -->
          <ng-container>
            <!-- PERSONEL INFO -->
            <div class="bg-primary text-white p-1">
              <h5 class="mt-2 ml-4">Personal Information
                <span>
                  <!-- <div class="greendot"></div> &nbsp; -->
                  <!-- <span class="greendot" data-toggle="tooltip" data-placement="top"
                    title="Created by Dr Syed Sulthan @ 12Mar2023 ">?
                  </span>&nbsp; -->
                  <!-- <span class="orangedot" data-toggle="tooltip" data-placement="top" title={{rec_data}}>?
                  </span> -->
                </span>
              </h5>
            </div>
            <div class="card m-b-30 col-12">
              <div class="card-body">
                <section class="mt-35 ml-2 container">
                  <form [formGroup]="forms['personalInformation']">
                    <div class="row card-body container-fluid ">

                      <div class="col-md-5">
                        <div class="row mb10">
                          <div class="col-6 col-md-4">
                            <label>First Name</label>
                          </div>
                          <div class="col-6 col-md-8" *ngIf="patient && patient.first_name">
                            {{patient?.first_name}}
                          </div>
                        </div>
                        <div class="row mb10">
                          <div class="col-6 col-md-4">
                            <label>Last Name</label>
                          </div>
                          <div class="col-6 col-md-8" *ngIf="patient && patient.last_name">
                            {{patient?.last_name}}
                          </div>
                        </div>

                        <div class="row mb10">
                          <div class="col-6 col-md-4 mt-2">
                            <label for="name">Date of Birth</label>
                          </div>
                          <div class="d-flex col-6 col-md-8">
                            <div class="d-flex">
                              <input class="form-control" placeholder="DOB(DD/MM/YYYY)" name="dob" formControlName="dob"
                                ngbDatepicker #ed="ngbDatepicker" data-date-inline-picker="false" id="dob"
                                [minDate]="miniDate" [maxDate]="currentDate" disabled />
                              <div>
                                <button class="btn btn-outline-secondary calendar rounded-0" (click)="ed.toggle()"
                                  type="button" style="line-height: 2.5;" id="endDateButton">
                                  <span class="fa fa-calendar"></span>
                                </button>
                              </div>
                            </div>
                            <div
                              *ngIf="getControl('dob').hasError('required') && !(getControl('dob').hasError('matDatepickerMax') || getControl('dob').hasError('matDatepickerMin') || getControl('dob').hasError('matDatepickerParse'))">
                              DOB is required</div>
                            <div
                              *ngIf="getControl('dob').hasError('matDatepickerMax') || getControl('dob').hasError('matDatepickerMin')">
                              DOB is invalid</div>
                            <!-- <mat-form-field class="border-top-0">
                              <input matInput [matDatepicker]="picker" [min]="minDate" [max]="maxDate"
                                formControlName="dob" [formControl]="getControl('dob')" readonly required>
                              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                              <mat-datepicker #picker></mat-datepicker>

                              <mat-error *ngIf="getControl('dob')">
                                <div *ngIf="getControl('dob').errors" class="invalid-feedback">Invalid DOB.
                                </div>

                                <div
                                  *ngIf="getControl('dob').hasError('required') && !(getControl('dob').hasError('matDatepickerMax') || getControl('dob').hasError('matDatepickerMin') || getControl('dob').hasError('matDatepickerParse'))">
                                  DOB is required</div>
                                <div
                                  *ngIf="getControl('dob').hasError('matDatepickerMax') || getControl('dob').hasError('matDatepickerMin')">
                                  DOB is invalid</div>
                              </mat-error>
                            </mat-form-field> -->
                          </div>

                        </div>

                        <div class="row mb10">
                          <div class="col-6 col-md-4 mt-2">
                            <label>Gender</label>
                          </div>
                          <div class=" col-6 col-md-8">
                            <editable (update)="updateField('gender')">
                              <ng-template viewMode>
                                {{patient && patient?.gender ?
                                patient?.gender.charAt(0).toUpperCase() +
                                patient?.gender.slice(1) : "Enter Gender"}}
                              </ng-template>
                              <ng-template editMode>
                                <select class="form-control" [formControl]="getControl('gender')"
                                  formControlName="gender" focusable>
                                  <option *ngFor="let x of gender" [value]="x?.key">
                                    {{x?.key}}
                                  </option>
                                </select>
                              </ng-template>
                            </editable>
                          </div>
                        </div>

                        <div class="row mb10">
                          <div class="col-6 col-md-4 mt-2">
                            <label>Blood Group</label>
                          </div>
                          <div class="col-6 col-md-8">
                            <editable (update)="updateField('blood_group')">
                              <ng-template viewMode>
                                {{patient && patient?.blood_group ?
                                patient?.blood_group.charAt(0).toUpperCase() +
                                patient?.blood_group.slice(1) : "Enter Blood Group"}}
                              </ng-template>
                              <ng-template editMode>
                                <select class="form-control" [formControl]="getControl('blood_group')"
                                  formControlName="blood_group" focusable>
                                  <option *ngFor="let x of blood_group" [value]="x?.key">
                                    {{x?.key}}
                                  </option>
                                </select>
                              </ng-template>
                            </editable>
                          </div>
                        </div>

                      </div>

                      <div class="col-md-5">
                        <div class="row">
                          <div class="col-6 col-md-4">
                            <label>Address</label>
                          </div>
                          <div class="col-6 col-md-8">
                            <p>
                              <editable (update)="updateField('address_1')">

                                <ng-template viewMode>
                                  {{patient && patient?.address_1 || "Enter address"}}
                                </ng-template>
                                <ng-template editMode>
                                  <input class="form-control" [formControl]="getControl('address_1')" focusable
                                    maxlength="150" />
                                  <div align="end">
                                    {{ getControl('address_1')?.value?.length || 0
                                    }}/ 150</div>
                                </ng-template>
                              </editable>
                            </p>
                            <p>
                              <editable (update)="updateField('address_2')">
                                <ng-template viewMode>
                                  {{ patient && patient.address_2 || "Enter address"}}
                                </ng-template>
                                <ng-template editMode>
                                  <input class="form-control" [formControl]="getControl('address_2')" focusable
                                    maxlength="150" />
                                  <div align="end">
                                    {{getControl('address_2')?.value?.length || 0}}/
                                    150</div>
                                </ng-template>
                              </editable>
                            </p>

                            <p>
                              <editable (update)="updateField('city_n')">

                                <ng-template viewMode>
                                  {{ patient && patient.city_n || "Enter City" }}
                                </ng-template>
                                <ng-template editMode>
                                  <input class="form-control" [formControl]="getControl('city_n')" focusable
                                    maxlength="30">
                                  <div align="end">
                                    {{ getControl('city_n')?.value?.length || 0 }}/
                                    30</div>
                                </ng-template>
                              </editable>
                            </p>

                            <p>
                              <editable (update)="updateField('zip')">
                                <ng-template viewMode>
                                  {{ patient && patient.zip || "Enter Pincode" }}
                                </ng-template>
                                <ng-template editMode>
                                  <input class="form-control" [formControl]="getControl('zip')" focusable
                                    maxlength="30">
                                  <div align="end">
                                    {{ getControl('zip')?.value?.length || 0 }}/
                                    6</div>
                                </ng-template>
                              </editable>
                            </p>
                          </div>
                        </div>


                        <div class="row mb10">
                          <div class="col-6 col-md-4 mt-2">
                            <label>State</label>
                          </div>
                          <div class=" col-6 col-md-8">
                            <editable (update)="updateField('state')">
                              <ng-template viewMode>
                                {{patient && patient?.state ?
                                patient?.state.charAt(0).toUpperCase() +
                                patient?.state.slice(1) : "Enter State"}}
                              </ng-template>
                              <ng-template editMode>
                                <select class="form-control" [formControl]="getControl('state')" formControlName="state"
                                  focusable>
                                  <option *ngFor="let x of state" [value]="x?.key">
                                    {{x?.key}}
                                  </option>
                                </select>
                              </ng-template>
                            </editable>
                          </div>
                        </div>


                        <div class="row">
                          <div class="col-6 col-md-4">
                            <label>Contact</label>
                          </div>
                          <div class="col-6 col-md-8">
                            <editable (update)="updateField('contact_no')">

                              <ng-template viewMode>
                                {{ patient && patient.contact_no || "Enter Contact Number" }}
                              </ng-template>
                              <ng-template editMode>
                                <input class="form-control" type="text" maxlength="12" pattern="[0-9]+"
                                  [formControl]="getControl('contact_no')" focusable min="0" minlength="10"
                                  maxlength="10" />
                                <div align="end">
                                  {{getControl('contact_no').value?.length || 0}}/ 10
                                </div>
                                <div
                                  *ngIf="getControl('contact_no').errors && !getControl('contact_no').errors.required"
                                  class="invalid-feedback">Invalid Contact Number</div>
                              </ng-template>
                            </editable>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-6 col-md-4">
                            <label>Email</label>
                          </div>
                          <div class="col-6 col-md-8">
                            <editable (update)="updateField('email_id')">

                              <ng-template viewMode>
                                {{ patient && patient.email_id || "Enter Email" }}
                              </ng-template>
                              <ng-template editMode>
                                <input class="form-control" [formControl]="getControl('email_id')" focusable
                                  maxlength="30" />
                                <div align="end">
                                  {{getControl('email_id').value?.length || 0}}/ 30
                                </div>
                                <div *ngIf="getControl('email_id').errors && !getControl('email_id').errors.required"
                                  class="invalid-feedback">Invalid Email</div>
                              </ng-template>
                            </editable>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-2">
                        <div class="row mb10">
                          <div class="avaitarImg">
                            <label class="hoverable" for="fileInput">

                              <!-- <img [src]="patient && patient.ppurl ? patient.ppurl : ''">
                              <div class="hover-text">Edit</div>
                              <div class="background"></div> -->

                              <img *ngIf="avatartimg != 'img_avatar.png'"
                                [src]="patient && patient?.ppurl ? patient?.ppurl : ''">
                              <div class="hover-text"><i class="fa fa-camera" style="font-size: 32px;"></i></div>
                              <div class="background"></div>

                              <div class="profileImage" *ngIf="avatartimg == 'img_avatar.png'">
                                <!-- <avatar *ngIf="avatartimg == 'img_avatar.png'" text={{patientname}}></avatar> -->
                                <img [src]="patient && patient?.ppurl ? patient?.ppurl : ''">
                                <div class="hover-text"><i class="fa fa-camera" style="font-size: 32px;"></i></div>
                                <div class="background"></div>
                              </div>
                            </label>
                            <br>
                            <input id="fileInput" type='file' accept=".png, .jpg, .jpeg"
                              (change)="fileSelected($event)">

                          </div>
                        </div>
                      </div>
                    </div>

                    <div> {{(createdby || createdat)? 'Created':''}} {{createdby? ' by: '+createdby:''}} {{createdat? '
                      on '+createdat:''}}</div>
                    <div>{{(updatedby || updatedat)? 'Last Updated ':''}} {{updatedby?' by: '+updatedby:''}}
                      {{updatedat? ' on '+updatedat:''}}</div>

                  </form>
                </section>
              </div>
            </div>



            <form [formGroup]="forms['medicalInformation']">


              <!-- HABITS -->
              <div class="bg-primary text-white p-1">
                <h5 class="mt-2 ml-4">Personal Habits</h5>
              </div>

              <div class="card m-b-30 col-12">
                <div class="card-body">
                  <section class="mt-35 ml-2 container">
                    <div class="row mb10" formArrayName="patient_appetite"
                      *ngFor="let item of getControl('patient_appetite')['controls']; let i = index;">

                      <div class="row" *ngIf="showFormArrayVal(i, 'patient_appetite', 'habit_id') !='Drugs'">

                        <div class="col-2 col-sm-8 col-md-2 m-m margin-top-20" [formGroupName]="i">
                          {{showFormArrayVal(i, 'patient_appetite', 'habit_id')}}
                        </div>
                        <div [formGroupName]="i" class="col-2 col-sm-8 col-md-2 m-m margin-top-20">
                          <div class="form-check form-check-inline">
                            <input class="form-check-input mb-0" type="radio" id="yes" formControlName="has_habit"
                              [value]=true (change)="checkedYes($event, i)" />
                            <label class="form-check-label" for="has_habit">Yes</label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input class="form-check-input mb-0" type="radio" id="no" formControlName="has_habit"
                              [value]=false (change)="checkedNo($event, i)" />
                            <label class="form-check-label" for="has_habit">No</label>
                          </div>
                        </div>

                        <div class="col-2 col-sm-8 col-md-2 m-m margin-top-20" [formGroupName]="i">
                          <editable (update)="updateField('patient_appetite')">
                            <ng-template viewMode>
                              Habit since {{showFormArrayVal(i, 'patient_appetite',
                              'since')}}
                            </ng-template>
                            <ng-template editMode>

                              <select formControlName="since" name="since" class="form-control">
                                <option value="">--Since--</option>
                                <option *ngFor=" let item of yearList" [value]="item">
                                  {{ item }}
                                </option>
                              </select>

                            </ng-template>
                          </editable>
                          <div *ngIf="formValidation(i, 'habit_details', 'patient_appetite')" class="invalid-feedback">
                            Required</div>
                        </div>

                        <div class="col-2 col-sm-8 col-md-2 m-m margin-top-20" [formGroupName]="i">
                          <editable (update)="updateField('patient_appetite')">
                            <ng-template viewMode>
                              {{showFormArrayVal(i, 'patient_appetite',
                              'habit_details')}}
                            </ng-template>
                            <ng-template editMode>
                              <input class="form-control" formControlName="habit_details" focusable>
                            </ng-template>
                          </editable>
                          <div *ngIf="formValidation(i, 'habit_details', 'patient_appetite')" class="invalid-feedback">
                            Required</div>
                        </div>

                        <div class="col-2 col-md-2 margin-top-20" [formGroupName]="i">
                          <editable (update)="updateField('patient_appetite')">
                            <ng-template viewMode>
                              {{showFormArrayVal(i, 'patient_appetite',
                              'frequency')}}
                            </ng-template>
                            <ng-template editMode>
                              <select formControlName="frequency" class="form-control">
                                <option value="">--Select Frequency--</option>

                                <option *ngFor=" let x of freqList" [value]="x.value">
                                  {{ x.value }}
                                </option>
                              </select>
                            </ng-template>
                          </editable>
                          <div *ngIf="formValidation(i, 'habit_details', 'patient_appetite')" class="invalid-feedback">
                            Required</div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>


              <!-- Medical History -->

              <div class="bg-primary text-white p-1">
                <h5 class="mt-2 ml-4">Past Medical History <i class="fa fa-plus float-right me-3"
                    (click)="addNewFormArray('patient_med_history')"></i>
                </h5>
              </div>

              <div class="card m-b-30 col-12">
                <div class="card-body">
                  <section class="mt-35 ml-2 container">
                    <div class="row mb10 margin-top-20" formArrayName="patient_med_history"
                      *ngFor="let item of getControl('patient_med_history')['controls']; let i = index;">
                      <div class="col-3 col-md-3" [formGroupName]="i">
                        <editable (update)="updateField('patient_med_history')">
                          <ng-template viewMode>
                            {{showFormArrayVal(i, 'patient_med_history',
                            'disease_id')}}
                          </ng-template>
                          <ng-template editMode>
                            <select class="form-control" name="expertise" formControlName="disease_id">
                              <option *ngFor="let x of diseaseList" [ngValue]="x?.id" [disabled]="isSelected(x?.id)">
                                {{x.disease_name}}</option>
                            </select>
                          </ng-template>
                        </editable>

                        <div *ngIf="formValidation(i, 'disease_id', 'patient_med_history')" class="invalid-feedback">
                          Required</div>
                      </div>
                      <div class="col-3 col-md-3" [formGroupName]="i">
                        <editable (update)="updateField('patient_med_history')">
                          <ng-template viewMode>
                            affected on {{showFormArrayVal(i, 'patient_med_history',
                            'since')}}
                          </ng-template>
                          <ng-template editMode>

                            <select formControlName="since" name="since" class=" form-control">
                              <option [value]="0">--Since--</option>
                              <option *ngFor="let item of yearList;" [value]="item">
                                {{item}}
                              </option>

                            </select>

                          </ng-template>
                        </editable>

                        <div *ngIf="formValidation(i, 'since', 'patient_med_history')" class="invalid-feedback">

                          Required
                        </div>
                      </div>

                      <div class="col-3 col-md-3" [formGroupName]="i">
                        <editable (update)="updateField('patient_med_history')">
                          <ng-template viewMode>
                            {{showFormArrayVal(i, 'patient_med_history',
                            'med_hist_info')}}
                          </ng-template>
                          <ng-template editMode>
                            <input class="form-control" formControlName="med_hist_info" focusable>
                          </ng-template>
                        </editable>
                        <!-- <i class="fa fa-close mr-0 closebutton" (click)="removeFromList('patient_med_history', i)"></i> -->
                        <div *ngIf="formValidation(i, 'med_hist_info', 'patient_med_history')" class="invalid-feedback">
                          Required</div>
                      </div>
                      <div class="col-1 col-md-1 "> <i class="fa fa-close mr-0 closebutton"
                          (click)="removeFromList('patient_med_history', i)"></i></div>
                    </div>


                  </section>
                </div>

              </div>


              <!-- Drug History -->
              <div class="bg-primary text-white p-1">
                <h5 class="mt-2 ml-4">Drug History <i class="fa fa-plus float-right me-3"
                    (click)="addNewFormArray('patient_medication')"></i>
                </h5>
              </div>

              <div class="card m-b-30 col-12">
                <div class="card-body">
                  <section class="mt-35 ml-2 container">
                    <div class="row mb10 margin-top-20" formArrayName="patient_medication"
                      *ngFor="let item of getControl('patient_medication')['controls']; let i = index;">
                      <div class="col-3 col-md-3" [formGroupName]="i">
                        <editable (update)="updateField('patient_medication')">
                          <ng-template viewMode>
                            {{showFormArrayVal(i, 'patient_medication',
                            'pmed_dose')}}
                          </ng-template>
                          <ng-template editMode>
                            <input class="form-control" formControlName="pmed_dose" focusable>


                          </ng-template>
                        </editable>

                        <div *ngIf="formValidation(i, 'pmed_dose', 'patient_medication')" class="invalid-feedback">
                          Required</div>
                      </div>

                      <div class="col-3 col-md-3" [formGroupName]="i">
                        <editable (update)="updateField('patient_medication')">
                          <ng-template viewMode>
                            consume from {{showFormArrayVal(i, 'patient_medication',
                            'since')}}
                          </ng-template>
                          <ng-template editMode>

                            <select formControlName="since" name="since" class=" form-control">
                              <option [value]="0">--Since--</option>
                              <option *ngFor="let item of yearList;" [value]="item">
                                {{item}}
                              </option>

                            </select>

                          </ng-template>
                        </editable>

                        <div *ngIf="formValidation(i, 'since', 'patient_medication')" class="invalid-feedback">

                          Required
                        </div>
                      </div>

                      <div class="col-3 col-md-3" [formGroupName]="i">
                        <editable (update)="updateField('patient_medication')">
                          <ng-template viewMode>
                            {{showFormArrayVal(i, 'patient_medication',
                            'pmed_freq')}}
                          </ng-template>
                          <ng-template editMode>
                            <select formControlName="pmed_freq" class="form-control">
                              <option value="">--Select Frequency--</option>

                              <option *ngFor=" let x of freqList" [value]="x.value">
                                {{ x.value }}
                              </option>
                            </select>
                          </ng-template>
                        </editable>

                        <!-- <i class="fa fa-close mr-0  closebutton " (click)="removeFromList('patient_medication', i)"></i> -->

                        <div *ngIf="formValidation(i, 'pmed_freq', 'patient_medication')" class=" invalid-feedback">
                          Required</div>
                      </div>


                      <div class="col-1 col-md-1 "> <i class="fa fa-close mr-0  closebutton "
                          (click)="removeFromList('patient_medication', i)"></i></div>
                    </div>

                  </section>
                </div>
              </div>

              <!-- =================  Drug Allergies ============= -->
              <div class="bg-primary text-white p-1">
                <h5 class="mt-2 ml-4">Drug Allergies</h5>
              </div>
              <div class="card-body">
                <section class="mt-35 ml-2 container">
                  <form [formGroup]="forms['allergyform']">
                    <div style="width:50%;white-space:pre-wrap" class="col-12 col-md-12">
                      <editable (update)="updateField('allergy')">

                        <ng-template viewMode style="width:50%;white-space:pre-wrap">
                          {{patient?.allergy || "Enter AllergyDetails" }}

                        </ng-template>

                        <ng-template editMode>
                          <textarea class="form-control" formControlName="allergy"> </textarea>
                          <div align="end">
                            {{getControl('allergy')?.value?.length || 0}}
                          </div>
                        </ng-template>

                      </editable>
                    </div>
                  </form>
                </section>
              </div>

              <!-- =================  Drug Allergies ============= -->
              <!-- <div class="bg-primary text-white p-1">
                <h5 class="mt-2 ml-4">Drug Allergies</h5>
              </div>
              <div class="card m-b-30">
                <div class="card-body">
                  <section class="mt-35 ml-2 align-items-center text-center container">
                    <form [formGroup]="forms['allergyform']">
                      <div class="row cust_row">
                        <label class="text-dark">Click here to describe the drug Allergy:
                          <span class="custom-control custom-switch d-inline-block">
                            <input type="checkbox" class="custom-control-input" id="enable"
                              [checked]="displayAllergybox"
                              (change)="checkValue((displayAllergybox = !displayAllergybox))" />
                            <label class="custom-control-label" for="enable"></label>
                          </span>
                        </label>


                        <div class="col-sm-12" *ngIf="displayAllergybox">
                          <div class="form-group">
                            <div class="row">
                              <div class="col-2 col-md-2 "></div>
                              <div class="col-10 col-sm-12 col-md-10 form-floating">
                              
                                <textarea class="form-control" formControlName="allergy"> </textarea>
                                <div align="end">
                                  {{getControl('allergy')?.value?.length || 0}}
                                </div>
                               
                                <label for="allergy" class="text-dark">Describe the Drug
                                  Allergies</label>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </section>
                </div>
              </div> -->



              <!-- Family Medical History -->
              <div class="bg-primary text-white p-1">
                <h5 class="mt-2 ml-4">Family Medical History</h5>
              </div>

              <div class="card m-b-30 ">
                <div class="card-body">
                  <section class="">

                    <div formArrayName="patient_fmed_history"
                      *ngFor="let item of getControl('patient_fmed_history')['controls']; let i = index;">
                      <div class="row">
                        <div class="col-2 col-sm-8 col-md-1 m-m margin-top-15 " [formGroupName]="i">
                          {{showFormArrayVal(i, 'patient_fmed_history', 'relation')}}
                        </div>

                        <div class="col-sm-12 col-md-6 margin-top-15 " [formGroupName]="i">
                          <input type="checkbox" id="yes" formControlName="diabetic" [value]=true
                            (change)="checkedYes($event, i)" />
                          Diabetic
                          &nbsp;
                          <input type="checkbox" id="yes" formControlName="cardio" [value]=true
                            (change)="checkedYes($event, i)" />
                          Cardio Vascular
                          &nbsp;
                          <input type="checkbox" id="yes" formControlName="tension" [value]=true
                            (change)="checkedYes($event, i)" />
                          Hyper Tension
                          &nbsp;
                          <input type="checkbox" id="yes" formControlName="cholestral" [value]=true
                            (change)="checkedYes($event, i)" />
                          High Cholestral
                        </div>

                        <div class="col-2 col-sm-12 col-md-2  m-m margin-top-15" [formGroupName]="i">
                          <editable (update)="updateField('patient_fmed_history')">
                            <ng-template viewMode>
                              {{showFormArrayVal(i, 'patient_fmed_history',
                              'status')}}
                            </ng-template>
                            <ng-template editMode>

                              <select name="live_status" class=" form-control" formControlName="status" name="status">
                                <option value=""> --Live Status-- </option>
                                <option value="Alive">Alive </option>
                                <option value="Deceased">Deceased </option>
                              </select>

                            </ng-template>
                          </editable>
                          <div *ngIf="formValidation(i, 'status', 'patient_fmed_history')" class="invalid-feedback">
                            Required</div>
                        </div>

                        <div class="col-3 col-sm-12 col-md-3 m-m margin-top-15" [formGroupName]="i">
                          <editable (update)="updateField('patient_fmed_history')">
                            <ng-template viewMode>
                              {{showFormArrayVal(i, 'patient_fmed_history',
                              'remarks')}}
                            </ng-template>
                            <ng-template editMode>

                              <input class="form-control" type="text" name="remarks" formControlName="remarks">
                            </ng-template>
                          </editable>
                          <div *ngIf="formValidation(i, 'remarks', 'patient_fmed_history')" class="invalid-feedback">
                            Required</div>
                        </div>

                      </div>
                    </div>

                  </section>
                </div>
              </div>

              <!-- LIFE STYLE -->

              <div class="bg-primary text-white p-1">
                <h5 class="mt-2 ml-4">Life Style</h5>
              </div>

              <div class="card m-b-30 col-12">
                <div class="card-body">
                  <section class="mt-35 ml-2 container">
                    <div class="row mb10 margin-top-20 " formArrayName="patient_lifestyle"
                      *ngFor="let item of getControl('patient_lifestyle')['controls']; let i = index;">
                      <div class="col-4 col-md-4" [formGroupName]="i">
                        {{showFormArrayVal(i, 'patient_lifestyle', 'activity')}}
                      </div>

                      <div class="col-4 col-md-4" [formGroupName]="i">
                        <editable (update)="updateField('patient_lifestyle')">
                          <ng-template viewMode *ngIf=" i===0  || i===1 ">
                            {{showFormArrayVal(i, 'patient_lifestyle',
                            'duration')}} -hours
                          </ng-template>
                          <ng-template viewMode *ngIf=" i===2 ">
                            {{showFormArrayVal(i, 'patient_lifestyle',
                            'duration')}} -hours
                          </ng-template>
                          <ng-template viewMode>
                            {{showFormArrayVal(i, 'patient_lifestyle',
                            'updatedby')}}
                          </ng-template>
                          <ng-template editMode>
                            <input class="form-control" formControlName="duration" focusable>
                          </ng-template>
                        </editable>
                        <div *ngIf="formValidation(i, 'duration', 'patient_lifestyle')" class="invalid-feedback">
                          Required</div>
                      </div>

                      <div class="col-4 col-md-4" [formGroupName]="i">
                        <editable (update)="updateField('patient_lifestyle')">
                          <ng-template viewMode>
                            {{showFormArrayVal(i, 'patient_lifestyle',
                            'freq')}}
                          </ng-template>
                          <ng-template editMode>
                            <select formControlName="freq" class="form-control">
                              <option value="">--Select Frequency--</option>

                              <option *ngFor=" let x of freqList" [value]="x.value">
                                {{ x.value }}
                              </option>
                            </select>
                          </ng-template>
                        </editable>
                        <div *ngIf="formValidation(i, 'freq', 'patient_lifestyle')" class="invalid-feedback">
                          Required</div>
                      </div>

                    </div>
                  </section>
                </div>
              </div>


            </form>
          </ng-container>

        </div>
      </div>
    </div>
  </div>
  <!-- ====ADDING BUTTON -->
  <div class="row">
    <div class="col-10"></div>
    <div class="col-2">

      <button type="button" class="btn btn-primary btn-patient pull-right" (click)="updatePatient()">Save</button>
    </div>
  </div>

</div>